var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 44.653c-2.318.557-4.878.86-7.696.86h-.608c-18.435 0-25.826-12.98-26.609-25.117a20.683 20.683 0 01-.087-1.64c.022-.27.033-.542.044-.82.01-.265.022-.536.043-.818.391-6.072 2.437-12.355 6.691-17.118H68a5 5 0 015 5v39.653z",
    fill: "#FF9F9F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1856_25822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.011 21.561c.084.644.14 1.297.17 1.957l-.15.006a22.743 22.743 0 010 1.952l.15.006a22.61 22.61 0 01-.17 1.957l-.149-.02c-.084.65-.197 1.29-.336 1.92l.146.033a22.361 22.361 0 01-.507 1.896l-.143-.045a22.079 22.079 0 01-.667 1.832l.139.058c-.252.606-.53 1.2-.831 1.779l-.133-.07a22.32 22.32 0 01-.977 1.688l.127.08a22.565 22.565 0 01-1.127 1.608l-.12-.092A22.448 22.448 0 0165.18 39.6l.111.102c-.442.482-.906.946-1.388 1.388l-.101-.11c-.48.438-.978.857-1.494 1.254l.092.119c-.519.398-1.055.774-1.607 1.127l-.08-.127c-.548.35-1.11.675-1.689.977l.07.133a22.37 22.37 0 01-1.78.83l-.057-.138c-.598.248-1.209.471-1.832.667l.045.143c-.62.196-1.253.365-1.896.507l-.032-.146c-.63.139-1.271.251-1.92.336l.019.149c-.644.084-1.297.14-1.956.169l-.007-.15a22.743 22.743 0 01-1.952 0l-.006.15a22.61 22.61 0 01-1.956-.17l.019-.148a22.37 22.37 0 01-1.92-.336l-.033.146a22.316 22.316 0 01-1.896-.507l.045-.143a22.137 22.137 0 01-1.832-.667l-.058.139c-.606-.252-1.2-.53-1.778-.831l.07-.133a22.3 22.3 0 01-1.689-.977l-.08.127a22.567 22.567 0 01-1.607-1.127l.09-.12a22.507 22.507 0 01-1.492-1.254l-.102.11a22.634 22.634 0 01-1.388-1.387l.11-.102a22.641 22.641 0 01-1.253-1.493l-.12.092a22.565 22.565 0 01-1.127-1.607l.127-.081c-.35-.547-.675-1.11-.977-1.688l-.133.07a22.387 22.387 0 01-.83-1.78l.138-.057c-.248-.598-.47-1.21-.667-1.832l-.143.045a22.286 22.286 0 01-.507-1.896l.146-.032a22.438 22.438 0 01-.336-1.92l-.149.019a22.689 22.689 0 01-.169-1.957l.15-.006a22.743 22.743 0 010-1.952l-.15-.006c.029-.66.085-1.313.17-1.957l.148.02c.085-.65.197-1.29.337-1.92l-.147-.033c.142-.643.311-1.275.507-1.896l.143.045c.196-.623.419-1.234.667-1.832l-.139-.058c.252-.607.53-1.2.831-1.779l.133.07a22.57 22.57 0 01.977-1.688l-.127-.08c.353-.553.73-1.09 1.128-1.608l.119.092a22.35 22.35 0 011.254-1.493l-.11-.102c.442-.482.905-.946 1.387-1.388l.102.11c.479-.439.977-.857 1.493-1.254l-.091-.118a22.557 22.557 0 011.605-1.13l.08.127a22.31 22.31 0 011.688-.977l-.07-.133c.58-.302 1.173-.58 1.78-.83l.057.138a22.21 22.21 0 011.832-.667l-.045-.143a22.205 22.205 0 011.896-.507l.032.146a22.576 22.576 0 011.92-.336l-.018-.149a22.63 22.63 0 011.956-.169l.006.15a22.743 22.743 0 011.952 0l.007-.15a22.1 22.1 0 011.956.17l-.02.148c.65.085 1.29.197 1.92.336l.033-.146c.643.142 1.275.311 1.896.507l-.045.143c.623.196 1.234.419 1.832.667l.058-.139c.607.252 1.2.53 1.779.831l-.07.133a22.57 22.57 0 011.688.977l.08-.127c.553.353 1.09.73 1.608 1.128l-.092.118c.516.397 1.015.815 1.494 1.255l.101-.11c.483.441.946.905 1.388 1.387l-.11.102c.439.479.857.977 1.254 1.493l.119-.092c.398.519.774 1.055 1.127 1.607l-.127.081c.35.547.676 1.11.977 1.688l.133-.07c.302.58.58 1.172.83 1.78l-.138.057c.248.598.471 1.21.667 1.832l.143-.045c.196.62.365 1.253.507 1.896l-.146.032c.139.63.252 1.271.336 1.92l.149-.019z",
    stroke: "#FF4848",
    strokeWidth: 0.3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.348 22.274c.125.632.21 1.278.253 1.936l-.15.01a14.986 14.986 0 010 1.936l.15.01a14.927 14.927 0 01-.253 1.936l-.147-.03a14.679 14.679 0 01-.5 1.869l.143.048c-.211.62-.461 1.223-.748 1.804l-.135-.066c-.287.58-.61 1.14-.968 1.674l.124.083c-.363.542-.76 1.06-1.19 1.549l-.112-.1a14.72 14.72 0 01-1.368 1.368l.1.113c-.49.43-1.007.827-1.55 1.19l-.083-.124a14.92 14.92 0 01-1.674.968l.066.134c-.58.287-1.183.538-1.804.748l-.048-.142c-.606.206-1.23.373-1.868.5l.03.147c-.633.125-1.28.21-1.937.253l-.01-.15a14.986 14.986 0 01-1.936 0l-.01.15a14.944 14.944 0 01-1.936-.253l.03-.147a14.7 14.7 0 01-1.869-.5l-.048.142a14.63 14.63 0 01-1.804-.748l.066-.134c-.58-.287-1.139-.61-1.673-.968l-.084.124a15.002 15.002 0 01-1.549-1.19l.1-.113a14.866 14.866 0 01-1.368-1.367l-.113.099c-.43-.49-.827-1.007-1.19-1.55l.125-.082a14.773 14.773 0 01-.969-1.674l-.134.066a14.848 14.848 0 01-.748-1.804l.142-.048a14.662 14.662 0 01-.5-1.868l-.147.029a14.944 14.944 0 01-.253-1.937l.15-.01a14.986 14.986 0 010-1.935l-.15-.01c.043-.658.128-1.304.253-1.936l.147.029c.127-.638.294-1.262.5-1.868l-.142-.048c.21-.621.46-1.223.748-1.804l.134.066c.287-.58.61-1.14.969-1.674l-.125-.083a14.8 14.8 0 011.19-1.549l.113.099c.425-.485.882-.942 1.367-1.367l-.099-.113c.49-.43 1.007-.827 1.55-1.19l.083.124a14.771 14.771 0 011.673-.968l-.066-.135a14.854 14.854 0 011.804-.748l.048.143c.606-.206 1.23-.374 1.868-.5l-.029-.147c.632-.125 1.279-.21 1.937-.253l.01.15a14.986 14.986 0 011.935 0l.01-.15c.658.043 1.304.128 1.936.253l-.029.147c.639.126 1.262.294 1.868.5l.048-.143c.621.211 1.223.462 1.804.748l-.066.135c.58.287 1.14.61 1.674.968l.083-.124c.543.363 1.06.76 1.55 1.19l-.1.113c.485.425.942.882 1.367 1.367l.113-.099c.43.49.827 1.006 1.19 1.549l-.124.083c.357.535.681 1.094.968 1.674l.135-.066c.287.58.537 1.183.748 1.804l-.142.048c.205.606.373 1.23.5 1.868l.146-.03z",
    stroke: "#FF4848",
    strokeWidth: 0.3,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1856_25822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.128 20.506a7.569 7.569 0 100-15.138 7.569 7.569 0 000 15.138z",
    fill: "#FF7676"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1856_25822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.473 38.465a4.472 4.472 0 100-8.945 4.472 4.472 0 000 8.945z",
    fill: "#FF7676"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1856_25822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.962 13.594h-5.034a.118.118 0 00-.117.117v.282h5.27v-.282a.117.117 0 00-.119-.117zm-4.046.047h.555v.305h-.555v-.305zm-.047.305h-.555v-.305h.555v.305zm.65-.305h.555v.305h-.556v-.305zm.602 0h.555v.305h-.555v-.305zm.602 0h.555v.305h-.555v-.305zm.602 0h.555v.305h-.555v-.305zm.602 0h.555v.305h-.555v-.305zm-4.07.07a.07.07 0 01.071-.07h.339v.305h-.41v-.235zm5.176.235h-.504v-.305h.433c.02 0 .037.007.05.02a.07.07 0 01.021.05v.235z",
    fill: "#FF4848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.633 10.28h-.306v1.269h.306v-1.27z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1856_25822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.821 12.418v-.705h.541a.73.73 0 00.73-.728h-4.117a.329.329 0 01.33-.33h2.87v-.081c0-.28-.194-.506-.433-.506h-3.577c-.55 0-1.054.355-1.314.917h-.576a.188.188 0 00-.13.053l-.365.352a.188.188 0 00.13.323h.454v.706h-2.08a.188.188 0 00-.14.063l-.42.47a.189.189 0 00.04.282c.03.02.065.03.102.03h1.293a.189.189 0 01.16.089l.226.363a.188.188 0 01-.145.287l-2.805.216a.189.189 0 00-.158.113l-.594 1.373a.188.188 0 00.173.262h9.373c.23 0 .459-.02.685-.062 1.673-.308 2.876-1.786 2.876-3.486h-3.129zm-4.752-.705h4.047v.706h-4.047v-.706zm5.881 1.505a.752.752 0 01-.752.752h-6.07a.751.751 0 01.753-.752h6.07z",
    fill: "#F5F4F0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.035 10.045c-.578.039-1.016.549-1.17.926h2.122c0-.154.154-.309.27-.309h2.932c.031-.308-.139-.542-.308-.617h-3.846z",
    fill: "#FF4848"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1856_25822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.165 43.144a9.151 9.151 0 100-18.303 9.151 9.151 0 000 18.303z",
    fill: "#FF7676"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1856_25822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.074 16.93a5.917 5.917 0 100-11.834 5.917 5.917 0 000 11.835z",
    fill: "#FF7676"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1856_25822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.327 36.042l.61-.038.557-1.505 1.964-.23.955 1.812-.053.501.133.463 6.288.077v-.231l.008-.627h-.343l.256-.26 1.22-1.505s2.097.078 2.123 0c.027-.077-.12-.867-.12-.867l-.901-.386-3.078-.347c-.677-1.562-1.288-2.295-1.288-2.295h-7.907l-.371 2.777v.007l-.053 2.654z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 36.348a1.972 1.972 0 003.942.073v-.002l.001-.07a1.972 1.972 0 00-3.942 0z",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.5 36.348a1.972 1.972 0 003.942.073v-.002l.001-.07a1.972 1.972 0 00-3.942 0z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.473 37.423a1.075 1.075 0 110-2.15 1.075 1.075 0 010 2.15z",
    fill: "#DCE0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.472 36.994a.645.645 0 110-1.29.645.645 0 010 1.29zm8.32-.646a1.972 1.972 0 003.941.073v-.002l.002-.07a1.972 1.972 0 00-3.943 0z",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.792 36.348a1.972 1.972 0 003.941.073v-.002l.002-.07a1.972 1.972 0 00-3.943 0z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.763 37.423a1.075 1.075 0 110-2.15 1.075 1.075 0 010 2.15z",
    fill: "#DCE0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.763 36.994a.645.645 0 110-1.29.645.645 0 010 1.29z",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.735 36.11s-.87-2.075-1.537-2.075h-1.624s-.406 0-.58.408l-.667 1.667h.522s.435-1.556.928-1.593c.493-.037 1.334 0 1.334 0s.29 0 .464.444c.174.445.763 1.413.763 1.413s.63.254.397-.264z",
    fill: "#FF4848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.984 35.75h1.018l.01 1.03-1.028-.31v-.72zm14.302-.976s.049-.333-.349-.554l-2.613-.185s-.426.037-.653.739l-.739 1.44v.222h.824s.398-1.958 1.534-1.884l1.244-.002s.12-.023.515.343l.237-.12zm-5.383-4.17H50.67c0-.09.031-.178.086-.242.056-.064.13-.1.209-.1h7.643a.25.25 0 01.113.026.296.296 0 01.096.074.37.37 0 01.064.111.393.393 0 01.022.131z",
    fill: "#FF4848"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.072 33.005h3.91a.316.316 0 00.126-.026.252.252 0 00.095-.073.186.186 0 00.02-.208l-.619-1.153c-.095-.178-.19-.411-.387-.517-.197-.106-.488-.08-.723-.08H55.12a.395.395 0 00-.127.02.344.344 0 00-.108.06.279.279 0 00-.072.09.235.235 0 00-.026.105v1.546c0 .03.008.062.022.09a.24.24 0 00.062.077.28.28 0 00.093.051.338.338 0 00.109.018z",
    fill: "#E93A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.327 33.274v.007l3.678.068.095-2.745h-3.374l-.4 2.67z",
    fill: "#FF4848"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M51.121 30.948h2.185c.06 0 .108.072.108.162v1.733c0 .09-.048.163-.108.163h-2.185c-.06 0-.108-.073-.108-.163V31.11c0-.09.048-.162.108-.162z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.815 33.691h.628c.016 0 .03.035.03.078v.188c0 .043-.014.078-.03.078h-.628c-.016 0-.029-.035-.029-.078v-.188c0-.043.013-.078.03-.078z",
    fill: "#FF4848"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1856_25822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.258 34.003c.08.03.222.054.385.073.444.053 1.053.072 1.053.072s3.129.26 5.474-.705c0 0 .34-.18.024-.42a1.018 1.018 0 00-.155-.094l-.004-.004a.822.822 0 00-.116-.09.813.813 0 00-.576-.129l-6.159.996s-.225.19.074.3z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.485 33.551l-1.29-.915-.567.098.556.968s1.286.01 1.301-.151zm-.842.525c.444.053 1.053.072 1.053.072s3.129.26 5.474-.705c0 0 .34-.18.024-.42l-.001.005s-.506.342-2.924.627l-3.626.421z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.057 34.056l-1.148.47-.289-.033.687-.516s.83-.177.75.08zm.503 1.621l.738.038 2.073-1.397.384-.26.187-.126c-.35-.296-1.78.113-1.78.113-.028.023-.037.061-.036.104a.638.638 0 00.06.218l-1.625 1.31z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.258 34.003c.08.03.222.054.385.073.444.053 1.053.072 1.053.072s3.129.26 5.474-.705c0 0 .34-.18.024-.42a1.018 1.018 0 00-.155-.094l-.004-.004a.822.822 0 00-.116-.09.813.813 0 00-.576-.129l-6.159.996s-.225.19.074.3z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.485 33.551l-1.29-.915-.567.098.556.968s1.286.01 1.301-.151zm3.247-.556l-2.568-.72-.414.087 1.16.521.363.406 1.46-.294z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.643 34.076c.444.053 1.053.072 1.053.072s3.129.26 5.474-.705c0 0 .34-.18.024-.42l-.001.005s-.506.342-2.924.627l-3.626.421z",
    fill: "#FF4848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.057 34.056l-1.148.47-.289-.033.687-.516s.83-.177.75.08zm.503 1.621l.738.038 2.073-1.397.384-.26.187-.126c-.35-.296-1.78.113-1.78.113-.028.023-.037.061-.036.104a.638.638 0 00.06.218l-1.625 1.31z",
    fill: "#F5F4F0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1856_25822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.912 11.623a1.343 1.343 0 011.327 1.08 1.352 1.352 0 01-.799 1.513 1.342 1.342 0 01-1.636-.492 1.352 1.352 0 01.596-1.997c.162-.068.336-.104.512-.104zm0-.574a1.908 1.908 0 00-1.766 1.181 1.92 1.92 0 00.413 2.088 1.91 1.91 0 003.262-1.353 1.908 1.908 0 00-1.91-1.917zm3.98-2.74a.65.65 0 00.656-.65v-.006A.65.65 0 0067.909 7a.652.652 0 00-.671.648.656.656 0 00.655.661zm1.37 3.314a1.343 1.343 0 011.327 1.08 1.352 1.352 0 01-.799 1.513 1.342 1.342 0 01-1.636-.492 1.352 1.352 0 01.597-1.997c.162-.068.336-.104.511-.104zm0-.574a1.907 1.907 0 00-1.764 1.182 1.92 1.92 0 00.414 2.086 1.909 1.909 0 003.26-1.354 1.92 1.92 0 00-1.179-1.768 1.906 1.906 0 00-.73-.146z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.907 9.592h-.982L67.32 8.36a.64.64 0 00-1.013-.136L64.84 9.641a.669.669 0 00-.19.46c0 .356.257.483.378.555.931.537 1.26.597 1.26.865v1.352a.329.329 0 00.558.232.329.329 0 00.096-.232v-1.846c0-.27-.622-.492-.989-.779l1.001-1.056c.383.585.56 1.056.778 1.056h1.175a.327.327 0 00.233-.56.327.327 0 00-.232-.096z",
    fill: "#FF4848"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1856_25822",
    x: 33.559,
    y: 5.368,
    width: 19.138,
    height: 19.138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_25822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1856_25822",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1856_25822",
    x: 22,
    y: 29.52,
    width: 12.945,
    height: 12.945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_25822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1856_25822",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1856_25822",
    x: 35.827,
    y: 10.068,
    width: 15.123,
    height: 7.899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_25822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1856_25822",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1856_25822",
    x: 46.014,
    y: 24.841,
    width: 22.303,
    height: 22.303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_25822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1856_25822",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1856_25822",
    x: 59.156,
    y: 5.096,
    width: 15.835,
    height: 15.835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_25822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1856_25822",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1856_25822",
    x: 48,
    y: 26,
    width: 18.39,
    height: 18.39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_25822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1856_25822",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1856_25822",
    x: 23.62,
    y: 32.275,
    width: 9.709,
    height: 5.44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_25822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1856_25822",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1856_25822",
    x: 61,
    y: 7,
    width: 11.172,
    height: 9.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1856_25822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1856_25822",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1856_25822"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(23)",
    d: "M0 0h50v50H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1856_25822"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(36 8)",
    d: "M0 0h14.044v9.26H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.12bc7cc654ea668589e0844250acc10d.svg";
export { ForwardRef as ReactComponent };